import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutdpRendition extends Layout {
    sourceRenbill: DataSource;
    textboxRenbId: Textbox;
    textboxRendProcRecs: Textbox;
    textboxRendRecs: Textbox;
    textboxRendTotalRecs: Textbox;
}
